import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoMerge = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Merge</title>
    <path
      d="M22.702 10.688 17 4.987l-5.702 5.701"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.837 5.314V18.02l-5.842 5.842M17 5.314V18.02l5.832 5.831"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <circle cx={24.711} cy={26.037} r={2.712} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <circle cx={8.906} cy={26.037} r={2.712} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);
export default SvgIcoMerge;
